import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { TriangleDownIcon, CloseIcon } from '@chakra-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateSortValues,
  selectSortValues,
  initialSortValues,
} from '../../../store/redux/slices/templateList.slice';

const SORT_OPTIONS = [
  { label: 'Newest first', sortBy: 'createdAt', sortOrder: 'desc' as const },
  { label: 'Oldest first', sortBy: 'createdAt', sortOrder: 'asc' as const },
];

function PassTemplateListSorter() {
  const dispatch = useDispatch();
  const sortValues = useSelector(selectSortValues);

  const hasSortApplied = Boolean(sortValues.sortBy && sortValues.sortOrder);
  const activeLabel =
    SORT_OPTIONS.find(
      (o) =>
        o.sortBy === sortValues.sortBy && o.sortOrder === sortValues.sortOrder
    )?.label || 'Sort by';

  const menuButtonProps = {
    as: Button,
    variant: 'outline',
    size: 'sm',
    borderRadius: '5px',
    bg: 'white',
    fontWeight: 400,
    color: hasSortApplied ? '#505E69' : '#4C4C4C',
    border: hasSortApplied ? '1.5px solid #505E69' : 'none',
    _hover: { borderColor: '#505E69' },
    _expanded: { borderBottomRadius: 0, bg: '#F8F8F8' },
  };

  return (
    <Menu placement="bottom-start" closeOnSelect gutter={0} matchWidth>
      <Flex align="center" position="relative">
        <MenuButton
          {...menuButtonProps}
          minW="100px"
          pr={hasSortApplied ? '43px' : '28px'}
        >
          <Text textTransform="none" letterSpacing="0.01em">
            {hasSortApplied ? activeLabel : 'Sort by'}
          </Text>
        </MenuButton>
        {hasSortApplied && (
          <CloseIcon
            aria-label="Clear sort"
            boxSize="9px"
            position="absolute"
            right="28px"
            cursor="pointer"
            zIndex={1}
            color="#989898"
            _hover={{ color: '#4C4C4C' }}
            onClick={() => dispatch(updateSortValues({ ...initialSortValues }))}
          />
        )}
        <TriangleDownIcon
          boxSize="10px"
          position="absolute"
          right="10px"
          pointerEvents="none"
        />
      </Flex>
      <MenuList
        minW="unset"
        w="full"
        borderTopRadius={0}
        borderBottomRadius="5px"
        border="none"
        boxShadow="md"
        py={0}
        overflow="hidden"
      >
        {SORT_OPTIONS.map((option) => {
          const isSelected =
            sortValues.sortBy === option.sortBy &&
            sortValues.sortOrder === option.sortOrder;
          return (
            <MenuItem
              key={`${option.sortBy}-${option.sortOrder}`}
              fontSize="13px"
              textStyle="bodyFamilyRegular"
              bg="#F8F8F8"
              _hover={{ bg: '#FFFFFF' }}
              _focus={{ bg: '#F8F8F8', _hover: { bg: '#FFFFFF' } }}
              onClick={() =>
                dispatch(
                  updateSortValues({
                    sortBy: option.sortBy,
                    sortOrder: option.sortOrder,
                  })
                )
              }
              fontWeight={isSelected ? 600 : 400}
              color={isSelected ? '#505E69' : '#4C4C4C'}
            >
              {option.label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}

export default PassTemplateListSorter;
